// Funções utilitárias para salvar e recuperar configurações do usuário no localStorage
// Agora com pageKey + contextKey para persistência contextualizada

export interface PersistedTableConfig {
  columns?: { key: string; visible?: boolean }[]
  filters?: Record<string, any>
  pagination?: { page: number; pageSize: number }
  sorting?: { field: string; direction: 'asc' | 'desc' }
  [key: string]: any
}

const STORAGE_PREFIX = 'ng_table_config_'

function makeStorageKey(pageKey: string, contextKey?: string) {
  return STORAGE_PREFIX + pageKey + (contextKey ? `__${contextKey}` : '')
}

export function saveTableConfig(pageKey: string, contextKey: string | undefined, config: PersistedTableConfig) {
  try {
    localStorage.setItem(makeStorageKey(pageKey, contextKey), JSON.stringify(config))
  } catch (e) {
    // fallback: ignore
  }
}

export function getTableConfig(pageKey: string, contextKey?: string): PersistedTableConfig | null {
  try {
    const data = localStorage.getItem(makeStorageKey(pageKey, contextKey))
    return data ? JSON.parse(data) : null
  } catch (e) {
    return null
  }
}

export function clearTableConfig(pageKey: string, contextKey?: string) {
  try {
    localStorage.removeItem(makeStorageKey(pageKey, contextKey))
  } catch (e) {}
}
